import React from "react";
import NewsletterThirtyFour from "../component/NewsletterThirtyFour";

function NewsletterThirtyFourContainer() {
  return <NewsletterThirtyFour />;
}

export default NewsletterThirtyFourContainer;
